export default {
  metaTitle: '清结算和账户',
  pageTitle: '清算单列表',
  fundAccount: '资金户',
  monthly: '月度',
  placeholder1: '时间过滤',
  previousMonth: '上月',
  bill: '帐单',
  nextMonth: '下月',
  noDataText1: '所选月份暂无系统帐单',
  checkDetails: '查看详情',
  exportExcel: '导出Excel',
  detail: '明细',
  detailBeta: '明细 (测试)',
  span1: '清算单号',
  span2: '所属帐期',
  span3: '店铺',
  span4: '状态',
  msg1: '接要信息',
  msg2: 'Item Total',
  msg3: '运费总额',
  msg4: '用户实付款总额',
  msg5: 'Coins抵扣总额',
  msg6: '平台券抵扣总额',
  msg7: '店铺券抵扣总额',
  msg8: '自发货COD货款',
  msg9: '自发货COD运费',
  msg10: '自发货订单COD收款 由卖家已收取的，需要在结算金额中扣减',
  msg11: '应扣减费项',
  msg12: '支付手续费总扣除',
  msg13: '店铺佣金总额',
  msg14: '平台收取(扣除)统收运费额',
  msg15: '应向店铺结算运费额',
  msg16: '平台收取(扣除)订单操作费额',
  msg17: '应结算Coins费用',
  msg18: '店铺券结算',
  msg19: '平台券应结算费用',
  msg20: '修正补偿',
  msg21: '清算结果',
  msg22: '应向卖家结算金额为',
  msg23: '所纳入清算的订单明细',
  msg24: '售后扣款数据',
  msg25: '暂未纳入统计',
  msg26: '平台卖家运作规则奖惩',
  msg27: '中国卖家物流费用',
  msg28: '数据修正补偿',
  msg29: '数据修正',
  msg30: '附加说明',
  msg31: '附件',
  msg32: '质疑账单',
  msg33: '发送确认回执',
  msg34: '出帐日为每月6日，未质疑或主动确认的清算帐单将在当月14号0时由系统自动确认',
  msg35: '已确认帐单无误',
  msg36: '操作日志',
  packageStatusMap1: '待发货',
  packageStatusMap2: '运输中',
  packageStatusMap3: '派送中',
  packageStatusMap4: '已完成',
  packageStatusMap5: '已拒收',
  packageStatusMap6: '已取消',
  payMethodList1: '在线支付',
  payMethodList2: '货到付款',
  // TODO 调整成日本对应物流(下面两项)
  shippingChannelList1: 'eCouerier-SUB',
  shippingChannelList2: 'E-Desh',
  shippingChannelList3: '自发货',
  // -------
  columns1: '单号',
  columns2: '月度',
  columns3: '店铺id',
  columns4: '店铺名',
  columns5: '国别',
  columns6: '自发货',
  columns7: '出帐日',
  columns8: '商品总计',
  columns9: '折扣',
  columns10: '运费总计',
  columns11: '用户实付',
  columns12: '计佣基数',
  columns13: '运费划归到平台',
  columns14: '应结算Coins额',
  columns15: '平台券应结算额',
  columns16: '支付手续费总扣除',
  columns17: '佣金',
  columns18: '操作费',
  columns19: '售后扣款',
  columns20: '奖惩金额',
  columns21: '物流费用',
  columns22: '应结算金额',
  columns23: '自发货COD金额',
  columns24: '自发货COD邮费',
  // ----------
  columnsTwo1: '发运包ID',
  columnsTwo2: '发运单含',
  columnsTwo3: '订单号',
  columnsTwo4: '店铺',
  columnsTwo5: '佣金率',
  columnsTwo6: '自发货',
  columnsTwo7: '自发货方式',
  columnsTwo8: '支付方式',
  columnsTwo9: '下单时间',
  columnsTwo10: '用户ID',
  columnsTwo11: '商品总额',
  columnsTwo12: '运费',
  columnsTwo13: '折扣',
  columnsTwo14: '积分抵扣',
  columnsTwo15: '平台券抵扣',
  columnsTwo16: '店铺券抵扣',
  columnsTwo17: '实付',
  columnsTwo18: '支付手续费',
  columnsTwo19: '国别',
  columnsTwo20: '操作费',
  columnsTwo21: '状态',
  columnsTwo22: '完成时间',
  columnsTwo23: '物流单号',
  // ----------
  year: '年',
  month: '月',
  error1: '所选月份暂无清算单',
  operateCode1: '数据修正',
  operateCode2: '卖家确认',
  operateCode3: '卖家质疑',
  operateCode4: '清算单创建',
  operateCode5: '系统确认',
  status1: '待卖家确认',
  status2: '卖家已确认',
  status3: '卖家质疑挂起',
  status4: '卖家已确认',
  confirmContent1: '将提交清算数据排查,后续结算操作将受影响，您要继续吗',
  confirmContent2: '您确认数据无误吗'
}
